import React from 'react';
import CampaignInfoTabView from './CampaignInfoTabView';
import { useCampaignInfoTabController } from '../../../controllers';
import { CampaignInfoTabProps } from '../../../types';

const CampaignInfoTab = (props: CampaignInfoTabProps) => {
  const viewModel = useCampaignInfoTabController(props);
  return <CampaignInfoTabView {...viewModel} />;
};

export default CampaignInfoTab;
